import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonshikbusonrent() {


const cardData = {
keyword: "Pune to Nashik Bus on Rent Packages",
headingDescription: "Ruturaj Enterprises provides Pune to Nashik Bus on Rent Packages for families, friends, corporate teams, wedding groups, pilgrimage travelers, and organized tourist groups. Comfortable AC, luxury, and suitable-capacity buses can be arranged for one-day tours, round trips, sightseeing programs, religious journeys, business travel, and extended Nashik visits. From convenient pickup arrangements in Pune to Nashik sightseeing and return transportation, the journey can be planned according to passenger strength, preferred destinations, travel duration, and group itinerary.",
topPlaces: [
{
title: "Trimbakeshwar Temple",
description: "Trimbakeshwar Temple is one of the most important religious destinations near Nashik and attracts devotees throughout the year. A dedicated bus from Pune makes group pilgrimage travel more convenient, particularly for families and larger groups planning temple visits along with other Nashik attractions."
},
{
title: "Sula Vineyards",
description: "Sula Vineyards is a well-known destination in the Nashik region, surrounded by scenic landscapes and vineyard areas. Groups visiting Nashik can include the destination in a planned tour itinerary while traveling together from Pune in a dedicated bus."
},
{
title: "Panchavati",
description: "Panchavati is an important cultural and religious area of Nashik with several temples and traditional attractions. A group bus can help families, pilgrims, and tourists visit multiple locations in the area without the need to arrange separate transportation for each stop."
},
{
title: "Saptashrungi Gad",
description: "Saptashrungi Gad is a significant pilgrimage destination located in the Nashik region and is visited by devotees from different parts of Maharashtra. A dedicated tourist or pilgrimage bus can provide convenient group transportation from Pune for a planned religious journey."
},
{
title: "Pandavleni Caves",
description: "Pandavleni Caves are historic rock-cut caves situated near Nashik and are a popular attraction for tourists and history enthusiasts. They can be included in a Nashik sightseeing itinerary along with other destinations when traveling from Pune by group bus."
},
{
title: "Anjaneri Hills",
description: "Anjaneri Hills is a scenic destination near Nashik associated with natural landscapes, trekking, and religious significance. Groups can include the area in an outdoor or sightseeing itinerary while using dedicated transportation from Pune."
},
{
title: "Ramkund",
description: "Ramkund is an important religious and cultural landmark located in the Panchavati area of Nashik. Group transportation makes it easier for families and pilgrims to visit Ramkund along with nearby temples and other attractions during a planned Nashik tour."
},
{
title: "Dudhsagar Falls",
description: "Dudhsagar Falls near Gangapur Dam is a seasonal attraction that can be included in recreational and sightseeing programs around Nashik. A bus tour provides convenient transportation for groups looking to combine scenic locations with their Nashik travel itinerary."
},
{
title: "Gangapur Dam",
description: "Gangapur Dam is a popular scenic location near Nashik and offers a relaxing setting for visitors and group outings. It can be incorporated into family trips, corporate outings, and tourist itineraries along with other nearby destinations."
},
{
title: "Kalaram Temple",
description: "Kalaram Temple in Panchavati is a prominent religious landmark and an important stop for visitors exploring Nashik's heritage and spiritual attractions. A dedicated bus allows groups to reach the temple comfortably and continue their planned sightseeing program."
}
],
services: [
{
name: "Pune to Nashik Bus Rental",
description: "Pune to Nashik Bus Rental is suitable for families, tourist groups, corporate teams, pilgrims, and wedding parties traveling together. Vehicle capacity and comfort level can be selected according to passenger count, travel duration, sightseeing requirements, and planned route."
},
{
name: "Pune to Nashik Bus Hire",
description: "Pune to Nashik Bus Hire provides dedicated transportation for groups traveling from Pune to Nashik for tourism, religious visits, business programs, events, and family trips. A hired bus keeps the group together and supports convenient travel throughout the planned itinerary."
},
{
name: "Pune to Nashik Bus Booking",
description: "Pune to Nashik Bus Booking allows groups to arrange transportation in advance for their preferred travel date and itinerary. Requirements such as passenger strength, AC preference, pickup location, sightseeing destinations, trip duration, and return schedule can be considered during planning."
},
{
name: "Pune Nashik Bus Tour Package",
description: "Pune Nashik Bus Tour Package provides an organized group travel solution for visitors exploring Nashik and its surrounding attractions. The itinerary can combine temples, caves, scenic locations, vineyards, and other selected destinations with convenient transportation from Pune."
},
{
name: "Pune Nashik Bus on Rent",
description: "Pune Nashik Bus on Rent is useful when families, friends, companies, or tourist groups need a dedicated vehicle for their complete journey. The bus can be arranged for one-day travel, extended stays, sightseeing programs, or round-trip requirements."
},
{
name: "Nashik Tour Package from Pune by Bus",
description: "Nashik Tour Package from Pune by Bus is designed for groups seeking comfortable transportation to explore Nashik's religious, historical, cultural, and scenic destinations. Travel planning can include selected attractions, sightseeing time, meal breaks, and return arrangements."
},
{
name: "Pune Nashik AC Bus Rental",
description: "Pune Nashik AC Bus Rental offers a comfortable travel option for passengers making the journey from Pune to Nashik. Air-conditioned buses are particularly suitable for families, corporate teams, tourists, and pilgrimage groups planning a full-day or longer trip."
},
{
name: "Luxury Bus for Nashik Tour Pune",
description: "Luxury Bus for Nashik Tour Pune is suitable for premium family holidays, corporate outings, special celebrations, wedding groups, and organized tours. Spacious seating and enhanced comfort can make the journey more pleasant when the group spends considerable time traveling and sightseeing."
},
{
name: "Pune to Nashik Tourist Bus",
description: "Pune to Nashik Tourist Bus services provide dedicated group transportation for sightseeing programs covering temples, caves, scenic attractions, and cultural destinations. The itinerary can be structured around multiple stops while keeping the complete group together."
},
{
name: "Pune Nashik Group Tour Bus",
description: "Pune Nashik Group Tour Bus is suitable for large groups traveling for holidays, pilgrimages, family functions, corporate programs, and social trips. Bus capacity can be matched with the number of travelers to provide organized and convenient group movement."
},
{
name: "Pune Nashik Family Tour Bus",
description: "Pune Nashik Family Tour Bus provides a convenient travel solution for family vacations, reunions, temple visits, celebrations, and sightseeing. Families can travel together from selected Pune pickup points and follow a customized Nashik itinerary."
},
{
name: "Pune Nashik One Day Tour Bus",
description: "Pune Nashik One Day Tour Bus is ideal for groups planning a same-day journey covering selected Nashik attractions. Departure, sightseeing stops, meal breaks, temple visits, and return timing can be organized according to the available travel schedule."
},
{
name: "Pune Nashik Round Trip Bus",
description: "Pune Nashik Round Trip Bus provides transportation for the complete journey from Pune to Nashik and back. It is suitable for sightseeing, family travel, pilgrimage programs, corporate visits, and group tours where return transportation needs to be coordinated in advance."
},
{
name: "Pune Nashik Outstation Bus Hire",
description: "Pune Nashik Outstation Bus Hire provides dedicated transportation for groups traveling outside Pune for tourism, religious journeys, business programs, and family trips. The bus can be arranged according to passenger capacity, travel duration, itinerary, and one-way or return requirements."
},
{
name: "Affordable Nashik Bus Package Pune",
description: "Affordable Nashik Bus Package Pune offers a practical transportation solution for groups planning a Nashik journey while keeping travel expenses under control. Selecting an appropriate bus size and planning an efficient itinerary can help balance affordability with passenger comfort."
},
{
name: "Nashik Sightseeing Bus from Pune",
description: "Nashik Sightseeing Bus from Pune is suitable for groups wanting to cover multiple attractions during a planned tour. Dedicated transportation makes it easier to move between Panchavati, temples, caves, scenic locations, and other selected destinations without arranging separate vehicles."
},
{
name: "Pune to Trimbakeshwar Bus Tour",
description: "Pune to Trimbakeshwar Bus Tour is designed for families, devotees, and organized pilgrimage groups traveling to the Trimbakeshwar Temple region. The journey can be planned as a one-day or extended trip with additional Nashik attractions included in the itinerary."
},
{
name: "Pune Nashik Pilgrimage Bus",
description: "Pune Nashik Pilgrimage Bus provides convenient group transportation for devotees visiting temples and religious destinations around Nashik. Routes can include Trimbakeshwar, Panchavati, Kalaram Temple, Ramkund, Saptashrungi, and other selected spiritual locations."
},
{
name: "Pune Nashik Corporate Bus Rental",
description: "Pune Nashik Corporate Bus Rental is useful for employee outings, business meetings, training programs, corporate visits, team trips, and official travel. A dedicated bus helps companies coordinate transportation between Pune offices, Nashik business locations, hotels, and event venues."
},
{
name: "Pune Nashik Wedding Bus Hire",
description: "Pune Nashik Wedding Bus Hire helps transport wedding guests and relatives between Pune, Nashik, hotels, function venues, and other locations connected with wedding programs. Dedicated group transportation makes it easier to coordinate guests around ceremonies and scheduled events."
},
{
name: "Pune Nashik Group Transportation",
description: "Pune Nashik Group Transportation provides a centralized travel solution for large groups heading to Nashik for tourism, pilgrimage, weddings, corporate programs, or family occasions. Vehicle arrangements can be planned around group size, pickup points, destinations, and journey duration."
},
{
name: "Nashik Tour Bus Booking Pune",
description: "Nashik Tour Bus Booking Pune helps travelers arrange suitable group transportation before their planned Nashik trip. Bus selection can be based on passenger count, AC or luxury preference, travel date, sightseeing itinerary, pickup location, and expected return schedule."
}
],
tableData: [
["Pune to Nashik Bus Rental", "Pune to Nashik Bus Hire"],
["Pune to Nashik Bus Booking", "Pune Nashik Bus Tour Package"],
["Pune Nashik Bus on Rent", "Nashik Tour Package from Pune by Bus"],
["Pune Nashik AC Bus Rental", "Luxury Bus for Nashik Tour Pune"],
["Pune to Nashik Tourist Bus", "Pune Nashik Group Tour Bus"],
["Pune Nashik Family Tour Bus", "Pune Nashik One Day Tour Bus"],
["Pune Nashik Round Trip Bus", "Pune Nashik Outstation Bus Hire"],
["Affordable Nashik Bus Package Pune", "Nashik Sightseeing Bus from Pune"],
["Pune to Trimbakeshwar Bus Tour", "Pune Nashik Pilgrimage Bus"],
["Pune Nashik Corporate Bus Rental", "Pune Nashik Wedding Bus Hire"],
["Pune Nashik Group Transportation", "Nashik Tour Bus Booking Pune"]
],
whychoose: [
{
WhyChooseheading: "Dedicated Pune to Nashik Transportation",
WhyChoosedescription: "A dedicated bus allows families, friends, pilgrims, and corporate groups to travel together from Pune without coordinating multiple cars. Pickup arrangements, departure timing, sightseeing stops, and return travel can be planned around the group's requirements."
},
{
WhyChooseheading: "Convenient for Religious Journeys",
WhyChoosedescription: "Nashik and its surrounding region include several important religious destinations that are frequently visited together. Group bus transportation makes it easier to plan visits to Trimbakeshwar, Panchavati, Ramkund, Kalaram Temple, and other selected pilgrimage locations."
},
{
WhyChooseheading: "Comfortable AC Travel Options",
WhyChoosedescription: "The Pune-Nashik journey can involve several hours of road travel and additional sightseeing. AC bus options provide a comfortable environment for families, tourists, corporate teams, and pilgrimage groups throughout the journey."
},
{
WhyChooseheading: "Flexible One-Day Itineraries",
WhyChoosedescription: "Groups with limited time can plan a one-day Nashik tour covering selected attractions before returning to Pune. Transportation can be coordinated around departure time, temple visits, sightseeing stops, meal breaks, and the preferred return schedule."
},
{
WhyChooseheading: "Suitable for Large Groups",
WhyChoosedescription: "Family functions, weddings, corporate programs, and pilgrimage tours can involve many passengers traveling on the same route. Selecting an appropriately sized bus helps keep the group together and simplifies movement between Pune and different Nashik destinations."
},
{
WhyChooseheading: "Useful for Corporate Travel",
WhyChoosedescription: "Companies may require group transportation for team outings, meetings, training programs, business visits, or employee events in Nashik. Dedicated buses provide an organized way to move teams between offices, hotels, venues, and planned destinations."
},
{
WhyChooseheading: "Sightseeing Around Nashik",
WhyChoosedescription: "A Nashik itinerary can combine religious landmarks, historic caves, scenic areas, and other attractions. Group bus travel allows passengers to follow a planned route and visit multiple destinations without repeatedly arranging local transportation."
},
{
WhyChooseheading: "Round-Trip Planning",
WhyChoosedescription: "Arranging onward and return transportation together gives groups greater convenience during a planned Nashik tour. The bus can follow the scheduled itinerary and remain part of the transportation plan until the group returns to Pune."
}
]
};








const faqData = [
{
question: "What are Pune to Nashik bus on rent packages?",
answer: "Pune to Nashik bus rental packages provide dedicated group transportation for families, friends, corporate teams, religious groups, and other parties traveling between the two cities. Ruturaj Enterprises can arrange a suitable bus according to passenger strength, trip duration, itinerary, and travel requirements."
},
{
question: "Can I hire a bus from Pune to Nashik for a round trip?",
answer: "Round-trip bus rental is a convenient option for groups traveling from Pune to Nashik and returning after completing their planned activities. The schedule can be coordinated with sightseeing, business visits, religious programs, family functions, overnight stays, and the preferred return date."
},
{
question: "Which places can be covered on a Pune to Nashik bus trip?",
answer: "A Nashik trip can include destinations such as Trimbakeshwar Temple, Sula Vineyards, Panchavati, Ram Kund, Pandavleni Caves, and other attractions around the city. The itinerary can be customized according to the group's purpose, available time, and preferred sightseeing locations."
},
{
question: "Is a rental bus suitable for a family trip from Pune to Nashik?",
answer: "Families can travel conveniently in a dedicated bus without having to coordinate multiple private vehicles. Everyone can stay together during the journey, while luggage and sightseeing schedules can be managed more easily throughout the Pune to Nashik trip."
},
{
question: "Can corporate groups book a Pune to Nashik rental bus?",
answer: "Corporate teams can hire a bus for business visits, conferences, employee outings, team-building activities, company events, and corporate travel. A dedicated vehicle helps employees travel together while maintaining a coordinated departure, activity, and return schedule."
},
{
question: "Can a bus be hired from Pune to Nashik for a pilgrimage?",
answer: "Religious groups can arrange a dedicated bus for Nashik pilgrimage trips, particularly when the itinerary includes Trimbakeshwar and other religious destinations. Traveling together allows devotees to follow a common schedule and simplifies transportation between different temple locations."
},
{
question: "What seating capacity is available for Pune to Nashik bus rental?",
answer: "The appropriate bus capacity depends on the number of passengers and luggage requirements. Ruturaj Enterprises can help identify a suitable vehicle for small groups as well as larger family parties, corporate teams, religious groups, school groups, and social organizations."
},
{
question: "Can we customize a Pune to Nashik bus rental package?",
answer: "The transportation package can be planned around your preferred pickup point, travel date, passenger count, sightseeing locations, trip duration, and return schedule. A customized itinerary is particularly useful for groups that want to combine Nashik sightseeing with business, religious, or family activities."
},
{
question: "How early should I book a bus from Pune to Nashik?",
answer: "Advance reservation is recommended for weekends, holidays, festivals, wedding functions, and pilgrimage periods when group transportation can be in higher demand. Providing the travel details early allows Ruturaj Enterprises to plan a suitable bus around your schedule."
},
{
question: "Why choose Ruturaj Enterprises for Pune to Nashik bus rental?",
answer: "Ruturaj Enterprises offers dedicated bus rental solutions for groups traveling from Pune to Nashik. Vehicle selection can be matched with passenger capacity, luggage, route, sightseeing plans, and journey duration, helping travelers organize their intercity trip with greater convenience."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Ganesh Pawar",
feedback:
"Our family group hired a bus from Pune to Nashik for a religious and sightseeing trip. Traveling together made it much easier to manage elderly family members and luggage. Ruturaj Enterprises helped us arrange convenient group transportation for our itinerary, and the overall journey was well organized.",
rating: 5
},
{
id: 2,
name: "Miss. Shweta More",
feedback:
"We planned a Nashik outing from Pune with a group of friends and needed one vehicle for the complete trip. The bus rental from Ruturaj Enterprises made our travel and sightseeing coordination much simpler. Everyone stayed together, and we could follow our planned schedule comfortably.",
rating: 5
}
];



































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Bus on Rent Packages",
  "image": "https://ruturajenterprises.com/assets/images/pune-to-nashik-bus-on-rent-packages.webp",
  "description":
    "Pune to Nashik Bus on Rent Packages for family holidays, group tours, religious journeys, corporate travel, weekend trips, and sightseeing. Ruturaj Enterprises offers comfortable AC and luxury buses from Pune to Nashik with suitable seating capacities, experienced drivers, flexible rental plans, and convenient pickup and drop arrangements. The service is suitable for Nashik city tours, temple visits, vineyard trips, family outings, and multi-day travel around Nashik and nearby destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/pune-to-nashik-bus-on-rent-packages"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Pune to Nashik Bus on Rent Packages | Pune Nashik Bus Rental | +91 9763381382
  </title>

  <meta
    name="description"
    content="Pune to Nashik Bus on Rent Packages for family trips, group tours, religious travel, corporate outings and sightseeing. Hire comfortable AC and luxury buses from Pune for Nashik tours, temple visits, vineyard trips and weekend travel."
  />

  <meta
    name="keywords"
    content="Pune to Nashik Bus Rental, Pune to Nashik Bus Hire, Pune to Nashik Bus Booking, Pune Nashik Bus Tour Package, Pune Nashik Bus on Rent, Nashik Tour Package from Pune by Bus, Pune Nashik AC Bus Rental, Luxury Bus for Nashik Tour Pune, Pune to Nashik Tourist Bus, Pune Nashik Group Tour Bus, Pune Nashik Family Tour Bus, Pune Nashik One Day Tour Bus, Pune Nashik Weekend Tour Bus, Pune to Nashik Bus Tour Package, Pune to Nashik AC Bus Rental, Pune to Nashik Luxury Bus Rental, Pune to Nashik Group Bus Rental, Pune to Nashik Family Bus Rental, Pune to Nashik One Day Bus Rental, Pune to Nashik Weekend Bus Rental, Pune Nashik Tourist Bus Rental, Pune Nashik Tour Bus Service, Nashik Bus Tour Package Pune, Nashik Bus Rental from Pune, Nashik Bus Hire from Pune, Nashik Bus Booking from Pune, Nashik Holiday Bus Package Pune, Nashik Family Tour Package Pune, Nashik Group Tour Package Pune, Nashik Weekend Trip Bus Pune, Nashik One Day Trip Bus Pune, Nashik Picnic Bus Rental Pune, Nashik Corporate Tour Bus Pune, Nashik Corporate Outing Bus Pune, Nashik Religious Tour Bus Pune, Nashik Temple Tour Bus from Pune, Pune to Nashik Bus for Family Trip, Pune to Nashik Bus for Group Travel, Pune to Nashik Bus for Corporate Trip, Pune to Nashik Bus for Religious Tour, Pune to Nashik Bus for Picnic, Pune to Nashik Bus for College Trip, Pune to Nashik Bus for School Trip, Pune to Nashik Outstation Bus Rental, Pune to Nashik Outstation Bus Hire, AC Bus on Rent Pune to Nashik, Luxury Bus on Rent Pune to Nashik, 20 Seater Bus Pune to Nashik, 32 Seater Bus Pune to Nashik, 35 Seater Bus Pune to Nashik, 45 Seater Bus Pune to Nashik, 50 Seater Bus Pune to Nashik, Pune Nashik Trimbakeshwar Bus Tour, Pune to Trimbakeshwar Bus Hire, Pune Nashik Sula Vineyard Tour Bus, Pune Nashik Temple Tour Bus, Pune to Nashik Sightseeing Bus, Nashik Sightseeing Bus from Pune, Pune to Nashik Tourist Bus Hire, Affordable Pune to Nashik Bus Rental, Ruturaj Enterprises Pune Nashik Bus Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonshikbusonrent ;